import { render, staticRenderFns } from "./PaymentOrderBigMealCard.vue?vue&type=template&id=2c9af1f9&scoped=true"
import script from "./PaymentOrderBigMealCard.vue?vue&type=script&lang=js"
export * from "./PaymentOrderBigMealCard.vue?vue&type=script&lang=js"
import style0 from "./PaymentOrderBigMealCard.vue?vue&type=style&index=0&id=2c9af1f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9af1f9",
  null
  
)

export default component.exports